import { Text } from '@genial/components';
import { Color, Typography } from '@genial/design-tokens';
import React from 'react';
import { Platform } from 'react-native';

import { ColoredSkeleton } from '../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';

interface StepTwoTermContentProps {
  loading: boolean;
  htmlContent?: string;
}

export const StepTwoTermContent: React.FC<StepTwoTermContentProps> = ({ loading, htmlContent }) => {
  return (
    <>
      <Text variant="semibold">Termo de Feefixo</Text>
      {loading ? (
        <ColoredSkeleton height="420px" borderRadius="sm" />
      ) : Platform.OS === 'web' ? (
        <iframe
          title="termo-fee-fixo"
          srcDoc={htmlContent || '<html><body><p>Nenhum termo disponível.</p></body></html>'}
          width="100%"
          height="420px"
          frameBorder="0"
          style={{
            borderRadius: 8,
            backgroundColor: Color['background'],
            fontFamily: Typography['fontfamily.base.regular'],
          }}
        />
      ) : (
        <Text>Visualização do termo disponível apenas na versão web.</Text>
      )}
    </>
  );
};
